import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import RADApplication from '@/Management/RADApplication';
import * as DownloadHelper from '@/Utility/DownloadHelper';


export default class EmbeddedMediumLinkViewModel extends ControlViewModel {

    link: any;

   
    public pdoId: KnockoutObservable<string>;
    public lockGroupID: KnockoutObservable<number>;
    public attributeName: KnockoutObservable<string>;
    public caption: KnockoutObservable<string>;
    

    public constructor(protected params: any) {
        super(params);
        this.pdoId = this.observableOrDefault(params.pdoId, null);
        this.lockGroupID = this.observableOrDefault(params.lockGroupID, null);
        this.attributeName = this.observableOrDefault(params.attributeName, "");
        this.caption = this.observableOrDefault(params.caption, "");



        let LinkViewModel = ComponentManager.getViewModel<any>('LinkViewModel');
        let LabelViewModel = ComponentManager.getViewModel<any>('LabelViewModel');

        
       

        let linkViewModelParameter = {
            label: new LabelViewModel({
                caption: this.defineComputed(() => {
                    return !!this.caption() ? this.caption():'-';
                })
            }),
            onClick: () => {
                DownloadHelper.openDownloadDialogFromApplicationAsync(this.getDownloadURL());
            }
        };

        this.link = new LinkViewModel(linkViewModelParameter);
    }

    private getDownloadURL(): string {
        let mediumHandler = RADApplication.getInstance().radEnvironmentMediumHandler;

        let query = '?PDOID=' + this.pdoId() + '&LockGroupID=' + this.lockGroupID() + '&AttributeName=' + this.attributeName() + '&Preview=false';
        let downloadUrl = mediumHandler + query;
        return downloadUrl;
    }
}

ComponentManager.setViewModel('EmbeddedMediumLinkViewModel', EmbeddedMediumLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');